import { useScreenSizeContext } from '@/components/ScreenSize.context';
import { getCriticsRatingNotes } from '@/utils/productCardUtils';
import { ProductModel, StoreConfModel } from '@/models';

import ProductRatingContainer from '@/components/common/product/rating/ProductRatingContainer';
import WishListIcon from '@/components/account/wishList/WishListIcon';

import styles from './HeaderProductImage.module.scss';

type HeaderProductImageProps = {
  product: ProductModel;
  scrollToRatings?: () => void;
  storeConf: StoreConfModel;
};

const HeaderProductImage = ({ product, scrollToRatings, storeConf }: HeaderProductImageProps) => {
  const { isMobile } = useScreenSizeContext();

  return (
    <div className={styles.container}>
      {!isMobile && (
        <ProductRatingContainer
          ratings={getCriticsRatingNotes(product, storeConf)}
          topRating={product.topRating}
          scrollToRatings={scrollToRatings}
        />
      )}
      <div className={styles.icon}>
        <WishListIcon product={product} />
      </div>
    </div>
  );
};

export default HeaderProductImage;
